import { Component } from '@angular/core';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';
import { PeopleflowFooterComponent } from 'src/app/peopleflow-footer/peopleflow-footer.component';

@Component({
  selector: 'app-payroll-custom-brand',
  imports: [HeaderLatestComponent , PeopleflowFooterComponent ],
  templateUrl: './payroll-custom-brand.html',
  styleUrl: './payroll-custom-brand.scss',
})
export class PayrollCustomBrand {

}
